import { arrayToDictionary } from 'utils/arrayToDictionary';
import { convertTreeToFlatItems } from 'utils/tree';

import { CustomFieldSelectAttributeOption } from '../types/customFields.types';
import { CreateAttributeApiArg } from '../types/customFieldsApi.types';

/**
 * Transforms the create attribute arg.
 *
 * @param attribute The attribute from the create attribute api arg.
 */
export function transformCreateAttributeArg(
  attribute: CreateAttributeApiArg['attribute'],
): Record<string, unknown> {
  return Object.assign(
    {},
    attribute,
    'options' in attribute
      ? { options: transformSelectAttributeOptionsArg(attribute.options) }
      : {},
  );
}

/**
 * Transforms custom select attribute options to conform with what the endpoint
 * expects. On frontend we choose to work with an array for simplicity sake
 * while backend expects an object.
 *
 * @param options The custom select attribute options.
 */
export function transformSelectAttributeOptionsArg(
  options: readonly CustomFieldSelectAttributeOption[] = [],
): Record<string, CustomFieldSelectAttributeOption> {
  return arrayToDictionary(
    convertTreeToFlatItems(options, { childrenKey: 'options' }),
    'id',
  );
}
